// TestimonialForm.js
import React, { useEffect, useState } from "react";
import axios from "axios";

const TestimonialForm = () => {
  const [userName, setUserName] = useState("");
  const [testimonial, setTestimonial] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  const accessToken = localStorage.getItem("authToken");

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://365luxuryhomes.com/api/testimonials",
        {
          userName,
          testimonial,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setMessage(response.data.message);
      setUserName("");
      setTestimonial("");
      setLoading(false);
    } catch (error) {
      setMessage("Failed to add testimonial. Please try again.");
      setLoading(false);
    }
  };

  // Fetch testimonials from the backend
  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(
        "https://365luxuryhomes.com/api/testimonials"
      );
      setTestimonials(response.data);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  };

  // Fetch testimonials on component mount
  useEffect(() => {
    fetchTestimonials();
  }, [testimonials]);

  return (
    <section className="p-5">
      <div className="max-w-xl">
        <h3 className="text-2xl text-[#aca9a5] font-medium mb-4">
          Add Testimonial
        </h3>
        <form onSubmit={handleSubmit}>
          <div>
            <label className="text-[#aca9a5] label" htmlFor="userName">
              User Name
            </label>
            <input
              type="text"
              id="userName"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              required
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            />
          </div>
          <div>
            <label htmlFor="testimonial" className="text-[#aca9a5] label">
              Review
            </label>
            <textarea
              id="testimonial"
              value={testimonial}
              onChange={(e) => setTestimonial(e.target.value)}
              required
              style={{
                width: "100%",
                height: "80px",
                marginBottom: "10px",
                padding: "8px",
              }}
            ></textarea>
          </div>
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#aca9a5",
              border: "none",
              cursor: "pointer",
            }}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
        {message && <p className="mt-2 text-[#aca9a5]">{message}</p>}
      </div>
      <div className="divider"></div>
      <div className="mt-4">
        <h3 className="text-2xl text-[#aca9a5] font-medium mb-4">
          Testimonials
        </h3>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-3 gap-4">
          {testimonials.length === 0 ? (
            <p>No testimonials found.</p>
          ) : (
            testimonials.map((testimonial) => (
              <div
                key={testimonial._id}
                className="mb-4 bg-white p-4 rounded-md"
              >
                <p className="text-[#aca9a5] font-medium">
                  {testimonial.userName}
                </p>
                <p className="mt-4 text-[#aca9a5]">{testimonial.testimonial}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default TestimonialForm;
